import { startApp } from './bootstrap/index';

startApp();
